/**
 * useMyAccess - the signed-in person's EFFECTIVE access, for screens deciding
 * what to show: { role, areas: { area: level }, noDelete, canManageAccess }.
 *
 * It is what the server said (GET /api/users/me, held by AppContext as
 * myAccess and re-read when a live 'users' event says access changed, so tabs
 * and buttons follow a change without a reload). Until that answer arrives -
 * or when it cannot be read - the role's own levels stand in, which is what
 * every screen showed before per-user access existed. Pass the result to
 * canSeeTab / canEdit / canDelete in data/roles.js.
 */
import { useMemo } from 'react';
import { useApp } from '../context/AppContext';
import { useAuth } from '../context/AuthContext';
import { getRole, isAdmin } from '../data/admins';
import { effectiveAccess } from '../data/roles';

export function useMyAccess() {
  const { myAccess, users } = useApp();
  const { user } = useAuth();
  const email = user?.email;
  return useMemo(() => {
    if (myAccess && myAccess.areas && typeof myAccess.areas === 'object') return myAccess;
    // the bootstrap admin always manages access (server/routes/users.js)
    return effectiveAccess(getRole(email, users), {}, { canManageAccess: isAdmin(email) });
  }, [myAccess, email, users]);
}

export default useMyAccess;
